import * as XLSX from "xlsx";

/**
 * CSV + Excel export for the Course list. Uses the same XLSX package the
 * rest of the app already ships with (attendance list, employee time
 * schedule) — no new dep. Both formats derive from the SAME row shape so
 * the two files always agree.
 */
export type CourseExportRow = {
  "Course Name": string;
  Code: string;
  Grade: string;
  Subject: string;
  Staff: string;
  Status: string;
  Materials: number | "";
  Assignments: number | "";
  "Start Date": string;
  "End Date": string;
};

function download(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function timestamp(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    d.getFullYear().toString() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) +
    "_" +
    pad(d.getHours()) +
    pad(d.getMinutes())
  );
}

export function exportCsv(rows: CourseExportRow[]) {
  const sheet = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(sheet);
  // BOM so Excel opens UTF-8 CSVs with accents rendered correctly.
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8" });
  download(blob, `courses_${timestamp()}.csv`);
}

export function exportXlsx(rows: CourseExportRow[]) {
  const sheet = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, sheet, "Courses");
  const buffer = XLSX.write(wb, { type: "array", bookType: "xlsx" });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  download(blob, `courses_${timestamp()}.xlsx`);
}
